import {DateTime} from "luxon";

const euroFormat = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });

export default {
  normalDate: (val) => {
    if (!val || isNaN(val)) return null;

    const date = new Date(val);
    if (date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0 && date.getMilliseconds() === 0) {
      return DateTime.fromMillis(val).toFormat("dd.LL.yyyy");
    } else {
      return DateTime.fromMillis(val).toFormat("dd.LL.yyyy HH:mm");
    }

  },
  euro: (val, fallback = null) => {
    if (val === null || val === undefined || val === "" || isNaN(val)) return fallback;
    return euroFormat.format(val);
  }
}
